import React, { useState, useEffect } from 'react';
import { useAdSurfaceAndSlot } from '../../hooks/useAdSurfaceAndSlot';
import { isValidAdDestination } from '../../utils/adDestinationUrl';
import { logHomeAds } from '../../config/ads';
import {
  BannerRoot,
  BannerLink,
  BannerOverlay,
  DismissBtn,
  BadgeRow,
  AdBadge,
  SponsorText,
} from './StaticAdBanner.styled';

export default function StaticAdBanner({ ad, variant = 'full', pageKey, onImpression, onLinkClick }) {
  const { loaded, slotVisible } = useAdSurfaceAndSlot(pageKey);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!onImpression || !ad?.managedCampaignId) return;
    onImpression();
  }, [onImpression, ad?.managedCampaignId]);

  useEffect(() => {
    if (!logHomeAds || pageKey !== 'home') return;
    const willRender = loaded && slotVisible && !dismissed && !!ad?.image;
    console.log('[simimovies/ads/home] StaticAdBanner', {
      variant,
      willRender,
      loaded,
      slotVisible,
      dismissed,
      hasImage: !!ad?.image,
      managedCampaignId: ad?.managedCampaignId ?? null,
    });
  }, [variant, loaded, slotVisible, dismissed, ad?.image, ad?.managedCampaignId, pageKey]);

  if (!loaded || !slotVisible || dismissed || !ad?.image) return null;

  const dest = isValidAdDestination(ad.url);
  const onNavigate = (e) => {
    if (!dest) {
      e.preventDefault();
      return;
    }
    onLinkClick?.(e);
  };

  return (
    <BannerRoot>
      <BannerLink
        href={dest ? ad.url : '#'}
        onClick={onNavigate}
        target={dest ? '_blank' : undefined}
        rel={dest ? 'noopener noreferrer sponsored' : undefined}
        $variant={variant === 'inline' ? 'inline' : 'full'}
      >
        <img src={ad.image} alt={ad.title} loading="lazy" decoding="async" />
        <BannerOverlay aria-hidden />
      </BannerLink>
      <DismissBtn type="button" onClick={() => setDismissed(true)} aria-label="Dismiss ad">
        ×
      </DismissBtn>
      <BadgeRow>
        <AdBadge>Ad</AdBadge>
        <SponsorText>{ad.sponsor}</SponsorText>
      </BadgeRow>
    </BannerRoot>
  );
}
